module.exports = __webpack_public_path__ + "static/media/task4Planet4.b3f50ea8.png";